// Envia vídeo grande em pedaços (o proxy corta uploads grandes de uma vez).
export const VIDEO_MAX_MB = 250;

export async function uploadVideo(api, { targetType, targetId, file, title = '', onProgress }) {
  const { data: init } = await api.post('/media/video/init', {
    target_type: targetType, target_id: targetId, filename: file.name, size: file.size,
  });
  const chunk = init.chunk_size;
  let offset = 0;
  while (offset < file.size) {
    const slice = file.slice(offset, offset + chunk);
    const buf = await slice.arrayBuffer();
    let res;
    for (let attempt = 0; attempt < 3; attempt += 1) {
      try {
        res = await api.put(`/media/video/${init.upload_id}/chunk`, buf, {
          params: { offset }, headers: { 'Content-Type': 'application/octet-stream' }, timeout: 180000,
        });
        break;
      } catch (e) {
        const retryable = !e.response || e.response.status >= 500;
        if (attempt === 2 || !retryable) throw e;
        await new Promise((r) => setTimeout(r, 1200));
      }
    }
    if (res.data.resend_from != null) offset = res.data.resend_from;
    else offset += slice.size;
    onProgress && onProgress(Math.min(99, Math.round((offset / file.size) * 100)));
  }
  const { data: rec } = await api.post(`/media/video/${init.upload_id}/complete`, { title }, { timeout: 300000 });
  onProgress && onProgress(100);
  return rec;
}
